/**
 * Composes srcset strings for Directus image transforms.
 * The z=.img suffix matches the existing Directus image cache convention.
 */

export const BREAKPOINTS = [400, 800, 1200, 1920] as const;
export const DEFAULT_CMS_IMAGE_QUALITY = 75;
export const DEFAULT_CMS_IMAGE_SIZES = "(min-width: 1920px) 1920px, 100vw";

export type CmsImageFormat = "avif" | "webp";

export function buildSrcSet(
  cmsPath: string,
  id: string,
  format: CmsImageFormat,
): string {
  return BREAKPOINTS.map(
    (w) =>
      `${cmsPath}/cms-assets/${id}?format=${format}&width=${w}&quality=${DEFAULT_CMS_IMAGE_QUALITY}&z=.img ${w}w`,
  ).join(", ");
}
